import { CalendarPlus, Apple } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { BUSINESS } from "@/utils/constants";

// Client-side "Add to Calendar" — no backend/credentials. Creates an editable
// appointment placeholder the customer confirms with Deuce's.
const pad = (n) => String(n).padStart(2, "0");
const fmt = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

const buildEvent = () => {
  const start = new Date(Date.now() + 24 * 60 * 60 * 1000);
  start.setUTCHours(14, 0, 0, 0); // ~9am ET placeholder
  const end = new Date(start.getTime() + 60 * 60 * 1000);
  return {
    title: "Deuce's Welding Appointment",
    details: `Welding / fabrication appointment with Deuce's Welding.\nCall or text: ${BUSINESS.phone}`,
    location: `Mobile Service — ${BUSINESS.area}`,
    start,
    end,
  };
};

export const AddToCalendar = () => {
  const ev = buildEvent();

  const googleUrl =
    "https://calendar.google.com/calendar/render?action=TEMPLATE" +
    `&text=${encodeURIComponent(ev.title)}` +
    `&dates=${fmt(ev.start)}/${fmt(ev.end)}` +
    `&details=${encodeURIComponent(ev.details)}` +
    `&location=${encodeURIComponent(ev.location)}`;

  const downloadIcs = () => {
    const ics = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//Deuces Welding//EN",
      "BEGIN:VEVENT",
      `UID:${Date.now()}@deuceswelding`,
      `DTSTAMP:${fmt(new Date())}`,
      `DTSTART:${fmt(ev.start)}`,
      `DTEND:${fmt(ev.end)}`,
      `SUMMARY:${ev.title}`,
      `DESCRIPTION:${ev.details.replace(/\n/g, "\\n")}`,
      `LOCATION:${ev.location}`,
      "ORGANIZER;CN=Deuce's Welding:mailto:" + BUSINESS.email,
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");
    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "deuces-welding-appointment.ics";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="add-to-calendar" className="mt-3 flex flex-wrap gap-3">
      <Button data-testid="cal-google" variant="outline" size="sm" href={googleUrl} target="_blank" rel="noopener noreferrer">
        <CalendarPlus size={15} /> Add to Google Calendar
      </Button>
      <Button data-testid="cal-ics" variant="outline" size="sm" onClick={downloadIcs}>
        <Apple size={15} /> Apple / Outlook (.ics)
      </Button>
    </div>
  );
};
